// extracted by mini-css-extract-plugin
module.exports = {"compact_vehicle":"homeGarageVehicleSelected_compact_vehicle__Xj2Q_"};